import React from "react";
import classes from "./PaymentReview.module.css";
import arrow from "../../Assets/icons/SVG/arrow.svg";
import { connect } from "react-redux";

class PaymentReview extends React.Component {
  state = {};

  render() {
    return (
      <div className={classes.parentContainer}>
        <div className={classes.heading}>
          <img src={arrow} width={40} height={25}></img>
          <h3>Review and Make Payment</h3>
        </div>

        <div className={classes.detailContainer}>
          <div className={classes.details}>
            <p>Interview Details</p>
            <div className={classes.detailsList}>
              <div className={classes.detailsListLeft}>
                <p>Interviewer Position Title:</p>
                <p>Interviewer Experience:</p>
                <p>Interview Date:</p>
                <p>Interview Time:</p>
              </div>
              <div className={classes.detailsListRight}>
                <p>Full Stack Developer</p>
                <p>5 years 6 months</p>
                <p>1 May (Fri)</p>
                <p>12:30 PM - 1:15 PM</p>
              </div>
            </div>
          </div>

          <div className={classes.price}>
            <p>Interview Price</p>
            <div className={classes.priceDetails}>
              <div className={classes.priceDetailsLeft}>
                <p>Interview Price:</p>
                <p>GST(%):</p>
                <p>Credits:</p>
              </div>
              <div className={classes.priceDetailsRight}>
                <p>&#8377; 680</p>
                <p>&#8377; 180</p>
                <p>&#8377; 0</p>
              </div>
            </div>
          </div>

          <div className={classes.totalPrice}>
            <p>Total Price:</p>
            <p>&#8377; 780</p>
          </div>

          <div className={classes.paymentButton}>
            <span>Confirm Payment</span>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    creditBalance: state.employeeReducer.creditBalance,
  };
};

export default connect(mapStateToProps)(PaymentReview);
